import { render, staticRenderFns } from "./PhonePayment.vue?vue&type=template&id=75ea6eb2&scoped=true&"
import script from "./PhonePayment.vue?vue&type=script&lang=js&"
export * from "./PhonePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ea6eb2",
  null
  
)

export default component.exports